import { PVSProvider } from '@/models/customers/PVSProvider.ts';

export const buildPatientFolderUrl = (pvs_provider: PVSProvider, domain: string, patient_id: string): string => {
    switch (pvs_provider) {
        case PVSProvider.DOC_CIRRUS: {
            return `${domain}/incase#/patient/${patient_id}/tab/casefile_browser`;
        }
        case PVSProvider.DATA_CUR: {
            return `${domain}/patienten/patientenstamm/${patient_id}`;
        }
        default: {
            return '';
        }
    }
};
